(function () {
  if (window.__calibrationBinding) return;
  window.__calibrationBinding = true;

  function is_valid_tape(val) {
    const n = Number(val);
    return Number.isInteger(n) && n >= 1 && n <= 40;
  }

  function is_valid_mm(val) {
    const s = String(val).trim();
    if (!s) return false;
    return /^(\d+)(\.\d+)?$/.test(s);
  }

  function setup_calibration_block(block) {
    if (!block || block.__cal_ready) return;
    block.__cal_ready = true;

    const radios = block.querySelectorAll('input[type="radio"][name="properties[Calibration input type]"]');
    const tapeWrap = block.querySelector('[data-mode="tape"]');
    const mmWrap = block.querySelector('[data-mode="mm"]');
    const tapeHelper = block.querySelector('[data-cal-helper="tape"]');
    const mmHelper = block.querySelector('[data-cal-helper="mm"]');
    const errorEl = block.querySelector('[data-cal-error]');
    const tapeInput = block.querySelector('input[data-cal-tape]');
    const mmInput = block.querySelector('input[data-cal-mm]');
    const tapeSubmit = block.querySelector('input[data-cal-submit-tape]');
    const mmSubmit = block.querySelector('input[data-cal-submit-mm]');


    function get_mode() {
      const checked = block.querySelector('input[type="radio"][name="properties[Calibration input type]"]:checked');
      return checked ? checked.value : 'Tape number';
    }

    function show_error(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || 'Please enter a valid calibration value.';
      errorEl.style.display = 'block';
    }

    function hide_error() {
      if (!errorEl) return;
      errorEl.style.display = 'none';
    }

    function sync_reporting_values() {
      const mode = get_mode();
      if (!tapeSubmit || !mmSubmit) return;

      if (mode === 'Measurement (mm)') {
        tapeSubmit.value = 'X';
        mmSubmit.value = (mmInput?.value || '').trim();
      } else {
        tapeSubmit.value = (tapeInput?.value || '').trim() || '20';
        mmSubmit.value = 'X';
      }
    }

    function update_ui() {
      const mode = get_mode();

      if (mode === 'Measurement (mm)') {
        if (tapeWrap) tapeWrap.style.display = 'none';
        if (mmWrap) mmWrap.style.display = 'block';
        if (tapeHelper) tapeHelper.style.display = 'none';
        if (mmHelper) mmHelper.style.display = 'block';
      } else {
        if (tapeWrap) tapeWrap.style.display = 'block';
        if (mmWrap) mmWrap.style.display = 'none';
        if (tapeHelper) tapeHelper.style.display = 'block';
        if (mmHelper) mmHelper.style.display = 'none';
        if (tapeInput && !tapeInput.value) tapeInput.value = '20';
      }

      hide_error();
      sync_reporting_values();   // ✅ add this
    }

    radios.forEach(r => r.addEventListener('change', update_ui));
    update_ui();

    tapeInput && tapeInput.addEventListener('input', sync_reporting_values);
    mmInput && mmInput.addEventListener('input', sync_reporting_values);
    sync_reporting_values(); // initial sync (belt + suspenders)

    const form = block.closest('form[action*="/cart/add"]') || block.closest('form');
    if (form && !form.__cal_submit_bound) {
      form.__cal_submit_bound = true;

      form.addEventListener('submit', function (e) {
        if (!form.contains(block)) return;

        const mode = get_mode();

        if (mode === 'Measurement (mm)') {
          const ok = mmInput && is_valid_mm(mmInput.value);
          if (!ok) {
            e.preventDefault();
            show_error('Please enter a valid millimeter measurement (e.g., 12.5).');
            mmInput && mmInput.focus();
            return;
          }
        } else {
          const ok = tapeInput && is_valid_tape(tapeInput.value);
          if (!ok) {
            e.preventDefault();
            show_error('Please enter a whole tape number from 1 to 40.');
            tapeInput && tapeInput.focus();
            return;
          }
        }

        // Write reporting values (selected value + X for other)
        if (mode === 'Measurement (mm)') {
          if (tapeSubmit) tapeSubmit.value = 'X';
          if (mmSubmit) mmSubmit.value = String(mmInput.value).trim();
        } else {
          if (tapeSubmit) tapeSubmit.value = String(tapeInput.value).trim();
          if (mmSubmit) mmSubmit.value = 'X';
        }

        hide_error();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-calibration]').forEach(setup_calibration_block);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();